const paths = {
  accountAssociatedAccounts: '/accounts/:accountId/associated-accounts',
  accountAssociatedLeaseAccounts: '/accounts/:accountId/associated-lease-accounts',
  accountDelinquency: '/accounts/:accountId/delinquency',
  accountReports: '/report-module/account-reports',
  accountListForPrinterReport: '/report-module/account-list-for-printer',
  accountNotes: '/accounts/:accountId/notes',
  accountOverview: '/accounts/:accountId/overview',
  accountPayments: '/accounts/:accountId/payments',
  accountPropertyAssetList: '/accounts/:accountId/property-asset-list',
  accounts: '/accounts',
  accountType: '/account-type',
  accountUsers: '/accounts/:accountId/users',
  adminUsers: '/admin-users',
  appraisalRegionReports: '/report-module/appraisal-region-reports',
  appraiserRegions: '/appraiser-regions',
  basicCost: '/basic-cost',
  batch: '/batch',
  businessBatchPenalty: '/batch/business-batch-penalty',
  leaseBatchPenalty: '/batch/lease-batch-penalty',
  telecomBatchPenalty: '/batch/telecom-batch-penalty',
  countySettings: '/county-settings',
  delinquency: '/delinquency',
  delinquentAdjustment: '/delinquency/adjustments',
  delinquentPostcardReport: '/report-module/delinquent-postcard-report',
  delinquentSummary: '/payments/delinquent-summary',
  emailingReports: '/report-module/mailing-reports',
  endOfYearReports: '/report-module/end-of-year',
  forgotPassword: '/forgot-password',
  home: '/',
  ironCountyTaxableValueReport: '/tyler-integration/reports/iron-county-taxable-value',
  leaseMasterAccountsPage: '/lease-master/accounts',
  leaseMasterAreasPage: '/lease-master/accounts/:accountNumber/areas',
  leaseMasterAssetReconciliation: '/lease-master/assets/reconciliation',
  leaseMasterDelinquencyPage: '/lease-master/accounts/:accountNumber/delinquency',
  leaseMasterNotesPage: '/lease-master/accounts/:accountNumber/notes',
  leaseMasterOverviewPage: '/lease-master/accounts/:accountNumber/overview',
  leaseMasterPaymentPostingPage: '/lease-master/payments/posting',
  leaseMasterPaymentReconciliationPage: '/lease-master/payments/reconciliation',
  leaseMasterReports: '/report-module/lease-master-reports',
  movePermits: '/report-module/move-permits',
  letterAndFormReports: '/report-module/letter-and-form',
  login: '/login',
  lookupTableMaintenance: '/table-maintenance',
  lookupTableAppraiserRegions: '/table-maintenance/appraiser-regions',
  lookupTableIndustrialParks: '/table-maintenance/industrial-parks',
  telecomAccountsPage: '/telecom/accounts',
  telecomOverviewPage: '/telecom/accounts/:accountNumber/overview',
  telecomAreasPage: '/telecom/accounts/:accountNumber/areas',
  telecomNotesPage: '/telecom/accounts/:accountNumber/notes',
  telecomDelinquencyPage: '/telecom/accounts/:accountNumber/delinquency',
  telecomPaymentPostingPage: '/telecom/payments/posting',
  telecomPaymentReconciliationPage: '/telecom/payments/reconciliation',
  masterAccountType: '/master/account-type',
  masterBasicCost: '/master/basic-cost',
  masterHome: '/master',
  masterLogin: '/master/login',
  masterPropertyClassification: '/master/property-classification',
  massAccounts: '/batch/mass-accounts',
  tylerIntegration: '/tyler-integration',
  tylerIntegrationMassAccounts: '/tyler-integration/mass-accounts',
  mcatHome: '/mcat',
  mcatLogin: '/mcat/login',
  mcatTelecomMaintenancePage: '/mcat/telecom/maintenance',
  mcatTelecomAccountsPage: '/mcat/telecom/accounts',
  mcatTelecomOverviewPage: '/mcat/telecom/accounts/:accountNumber/overview',
  mcatTelecomAreasPage: '/mcat/telecom/accounts/:accountNumber/area',
  mcatTelecomNotesPage: '/mcat/telecom/accounts/:accountNumber/notes',
  notificationFileReports: '/report-module/notification-files',
  passwordReset: '/password-reset',
  paymentDelinquentYear: '/payments/delinquent-year',
  paymentReports: '/report-module/payment-reports',
  paymentReturnedPayment: '/payments/returned-payment',
  payments: '/payments',
  paymentSearch: '/payments/search',
  paymentSummary: '/payments/summary',
  paymentTotals: '/payments/daily-totals',
  profile: '/profile',
  propertyClassification: '/property-classification',
  reconciliation: '/reconciliation/:accountId',
  reconciliationAccountInformation: '/reconciliation/:accountId/account',
  reconciliationContacts: '/reconciliation/:accountId/contacts',
  reconciliationLeasedAssets: '/reconciliation/:accountId/leased-assets',
  reconciliationLessors: '/reconciliation/:accountId/lessors',
  reconciliationPropertyAssets: '/reconciliation/:accountId/assets',
  reconciliationSummary: '/reconciliation/:accountId/summary',
  refunds: '/payments/refunds',
  refundsBatch: '/payments/refunds/batch',
  refundsBatchWithId: '/payments/refunds/batch/:id',
  refundsBatchSearch: '/payments/refunds/batch/search',
  refundsSearch: '/payments/refunds/search',
  resetPasswordSent: '/forgot-password/sent',
  roles: '/roles',
  sicCodeMasters: '/sic-code-master',
  sicCodes: '/sic-code-list',
  sicSiloCodes: '/sic-silo-list',
  statusReport: '/report-module/status-reports',
  subSiloCodes: '/sic-sub-list',
  taxAreaList: '/report-module/tax-area-list',
  voidDelinquentPayment: '/payments/void-delinquent-payment',
  massPayments: '/payments/mass-payment',
  unauthorized: '/unauthorized',
} as const

export type Path = typeof paths[keyof typeof paths]

export default paths
